import { type Dispatch, type SetStateAction, useEffect, useRef } from 'react';

export const useAvailableDefault = <Option>(
  enabled: boolean,
  options: Option[],
  selected: Option[] | undefined,
  setSelected: Dispatch<SetStateAction<Option[] | undefined>>,
  isDisabled: (option: Option) => boolean,
) => {
  const userSelected = useRef(false);

  useEffect(() => {
    if (!enabled || userSelected.current) return;
    if (selected?.length && !isDisabled(selected[0])) return;

    const available = options.find((option) => !isDisabled(option));
    if (available !== undefined) {
      setSelected([available]);
    } else if (selected?.length) {
      setSelected([]);
    }
  }, [enabled, options, selected, setSelected, isDisabled]);

  const selectByUser: Dispatch<SetStateAction<Option[] | undefined>> = (
    value,
  ) => {
    userSelected.current = true;
    setSelected(value);
  };

  return selectByUser;
};
